import React from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    heading: 'About this English version',
    body: [
      `English translation of 🇰🇷 코레디 개인정보처리방침 (개인회원). Provided for the convenience of Users. The Korean version is the official version — see Supplementary Provisions.`,
      ``,
      `Oing Lab (brand name "Koready", hereinafter the "Company") establishes and discloses this Privacy Policy in accordance with Article 30 of the Personal Information Protection Act, in order to protect the personal information of data subjects and to handle related grievances promptly and smoothly. The Company complies with applicable laws, including the Personal Information Protection Act and the Act on Promotion of Information and Communications Network Utilization and Information Protection, Etc.`,
    ],
  },
  {
    heading:
      'Article 1 (Purposes and Legal Bases for Processing Personal Information)',
    body: [
      `① The Company processes personal information for the following purposes. The legal basis for each item is set out below in accordance with the subparagraphs of Article 15(1) of the Personal Information Protection Act.`,
      {
        type: 'table',
        headers: ['Items collected', 'Purpose of processing', 'Legal basis'],
        rows: [
          [
            'Email, name, country and city of residence, date of birth',
            'Registration and account management, provision of the Service',
            'Performance of a contract (Subparagraph 4) or consent (Subparagraph 1)',
          ],
          [
            'Gender (optional)',
            'Service improvement and statistics',
            'Consent (Subparagraph 1)',
          ],
          [
            'Profile photo (optional)',
            'Display of the account profile',
            'Consent (Subparagraph 1)',
          ],
          [
            'Payment information (method, currency, transaction ID, etc.)',
            'Payment and refund processing',
            'Performance of a contract (Subparagraph 4), legal obligation (Subparagraph 2)',
          ],
          [
            'Phone number, education and career information (optional)',
            'Career and settlement support (Pathfinder and similar)',
            'Consent (Subparagraph 1)',
          ],
          [
            'Access logs, cookies, analytics data',
            'Service improvement, prevention of misuse',
            'Legitimate interests (Subparagraph 6) or consent (Subparagraph 1)',
          ],
          [
            'Name, contact number, email',
            'Verifying identity, confirming complaints, contacting and notifying for fact-finding, notifying results, and responding to customer inquiries',
            'Performance of a contract (Subparagraph 4) or consent (Subparagraph 1)\nRecords of consumer complaints and dispute handling: legal obligation (Subparagraph 2)',
          ],
          [
            '[Required]\nBasic information (name, date of birth, gender, email, mobile number, address), career history (company name, position, start date, end date), visa information (status of stay, visa issue date, expiry date)\n\n[Optional]\nPhoto, portfolio, other documents (files), employment type and location of previous roles, detailed achievements within each role, duration of each role, Korean name, TOPIK and other language certificates, training and extracurricular activities, education history (degree, school name, major, admission date, graduation date)',
            'Job application services through resume registration',
            'Consent (Subparagraph 1)\nConducting the application process: performance of a contract (Subparagraph 4)\nProvision to Corporate Members: separate consent (Article 17 of the Act; Article 6-2 of this Policy)',
          ],
        ],
      },
      ``,
      `② Where the Company processes personal information on the basis of legitimate interests, it does so only within the scope in which those interests clearly outweigh the rights of the data subject.`,
      ``,
      `③ Users may refuse consent for items processed on the basis of consent. If consent is refused, use of the related services (resume registration and job applications, career and settlement support, and similar) may be restricted. Refusing consent does not affect registration or use of the basic Service.`,
    ],
  },
  {
    heading: 'Article 2 (Items of Personal Information Collected)',
    body: [
      `① (Required) Email, name, country and city of residence, date of birth`,
      ``,
      `② (Optional) Gender, profile photo, phone number, work and academic experience, information on participation in learning and workshops`,
      ``,
      `③ (At payment) Payment method and currency, payment amount, status and date, refund status, payment approval number or transaction ID (including PayPal transaction ID)`,
      ``,
      `④ (When using Pathfinder) The current country and city of residence and the school name and school location that the User enters directly. The Company does not use automatic location tracking such as GPS or device location APIs.`,
      ``,
      `⑤ (Automatically collected) Device and browser type, pages visited and navigation path, approximate region (not precise location), and logs such as access time and errors`,
    ],
  },
  {
    heading:
      'Article 2-2 (Items Collected for Resume Registration and Job Applications)',
    body: [
      `① (Required) Basic information (name, date of birth, gender, email, mobile number, address), career history (company name, position, start date, end date), visa information (status of stay, visa issue date, expiry date)`,
      ``,
      `② (Optional) Photo, portfolio, other documents (files), employment type and location of previous roles, detailed achievements within each role, duration of each role, Korean name, TOPIK and other language certificates, training and extracurricular activities, education history (degree, school name, major, admission date, graduation date)`,
      ``,
      `③ Personal information contained in a resume is provided to a Corporate Member under Article 6-2 only where the User applies to a job posting.`,
    ],
  },
  {
    heading: 'Article 3 (Methods of Collecting Personal Information)',
    body: [
      `The Company collects personal information either directly from the data subject or through automatic collection devices such as cookies, in the course of registration, use of the Service, payment, inquiries and consultations, event entries, and website use.`,
    ],
  },
  {
    heading: 'Article 4 (Processing and Retention Periods)',
    body: [
      `① In principle, the Company destroys personal information without delay once the purpose of processing has been achieved or upon withdrawal of membership. However, the following information is retained for the periods set out below in accordance with applicable laws.`,
      {
        type: 'table',
        headers: ['Item retained', 'Retention period', 'Legal basis'],
        rows: [
          [
            'Records on contracts or withdrawal of subscription',
            '5 years',
            'Article 6 of the Enforcement Decree of the Act on the Consumer Protection in Electronic Commerce, Etc.',
          ],
          [
            'Records on payment and supply of goods or services',
            '5 years',
            'Article 6 of the Enforcement Decree of the Act on the Consumer Protection in Electronic Commerce, Etc.',
          ],
          [
            'Records on consumer complaints or dispute handling',
            '3 years',
            'Article 6 of the Enforcement Decree of the Act on the Consumer Protection in Electronic Commerce, Etc.',
          ],
          [
            'Records on labelling and advertising',
            '6 months',
            'Article 6 of the Enforcement Decree of the Act on the Consumer Protection in Electronic Commerce, Etc.',
          ],
          [
            'Website access logs',
            '3 months or more',
            'Protection of Communications Secrets Act; Standards for Measures to Secure the Safety of Personal Information',
          ],
        ],
      },
      ``,
      `② Even after account deletion, information subject to a statutory retention obligation is stored separately from other personal information and is not used for any purpose other than that prescribed by law.`,
    ],
  },
  {
    heading:
      'Article 4-2 (Retention Periods for Resume and Job Application Information)',
    body: [
      `① Resume information is destroyed without delay upon withdrawal of membership or when the User deletes the resume.`,
      ``,
      `② Job application records are retained until withdrawal of membership and are destroyed without delay upon withdrawal. However, records subject to a statutory retention obligation under Article 4(1) are retained for the applicable period.`,
      ``,
      `③ The criteria for terminating a Corporate Member's right to view resumes and Application Documents provided to that Corporate Member are set out in Article 6-2.`,
    ],
  },
  {
    heading: 'Article 5 (Personal Information of Persons Under 18 and Children)',
    body: [
      `① The Service is intended for persons aged 18 or older, and the Company restricts registration by persons under 18 through date-of-birth verification at sign-up.`,
      ``,
      `② In accordance with Article 22-2 of the Personal Information Protection Act, the Company does not, in principle, collect personal information from children under 14. Where such collection is unavoidable, the Company obtains the consent of a legal representative. If the Company becomes aware that a child under 14 has registered without the consent of a legal representative, it destroys the relevant information without delay.`,
    ],
  },
  {
    heading: 'Article 6 (Provision of Personal Information to Third Parties)',
    body: [
      `① The Company processes personal information only within the scope of the purposes set out in Article 1, and provides it to third parties only where the data subject has consented or where there is a legal basis, in accordance with Articles 17 and 18 of the Personal Information Protection Act.`,
      ``,
      `② Where personal information is provided to a third party, the Company informs the data subject of the recipient, the purpose of provision, the items provided, and the recipient's retention and use period, and obtains consent.`,
    ],
  },
  {
    heading:
      'Article 6-2 (Provision of Personal Information to Third Parties Following a Job Application)',
    body: [
      `① The Company provides personal information to Corporate Members as set out below, only where the User applies to a job posting.`,
      {
        type: 'table',
        headers: [
          'Recipient',
          'Purpose of provision',
          'Items provided',
          'Retention and use period',
        ],
        rows: [
          [
            'The Corporate Member that registered the job posting to which the User applied',
            'Conducting the recruitment process and contacting the applicant',
            'Personal information items and attached files contained in the resume and Application Documents',
            'If finally hired: 90 days from the official start date\nIf not selected: upon the close of the relevant recruitment process',
          ],
        ],
      },
      ``,
      `② The Company does not provide resumes to Corporate Members or allow them to view resumes without the User's application, and does not provide any function that allows Corporate Members to search resumes.`,
      ``,
      `③ The Company clearly displays the details of the provision under Paragraph 1 on the application screen and obtains the User's consent. An application does not proceed without this consent.`,
      ``,
      `④ Once the retention and use period under Paragraph 1 has passed, the Company automatically terminates the relevant Corporate Member's viewing rights, and the Corporate Member may not retain the information for recruitment purposes thereafter.`,
      ``,
      `⑤ A User may withdraw an application, or withdraw consent to the provision under Paragraph 1, even while a recruitment process is ongoing. In that case the Company terminates the relevant Corporate Member's viewing rights without delay. However, destruction of personal information already provided follows that Corporate Member's personal information handling standards and applicable laws.`,
    ],
  },
  {
    heading: 'Article 7 (Entrustment of Personal Information Processing)',
    body: [
      `① The Company entrusts personal information processing tasks as set out below for the provision of the Service. In accordance with Article 26 of the Personal Information Protection Act, the Company discloses the entrustment and supervises the entrusted parties.`,
      {
        type: 'table',
        headers: ['Entrusted party', 'Entrusted task', 'Notes'],
        rows: [
          [
            'Amazon Web Services',
            'Cloud hosting and data storage',
            'Seoul region',
          ],
          [
            'Toss Payments, PayPal',
            'Payment and refund processing',
            'PayPal involves overseas processing (Article 8)',
          ],
          [
            'Google (Google Meet)',
            'Operation of online live sessions',
            'Overseas processing (Article 8)',
          ],
          [
            'Google (Analytics 4), Microsoft (Clarity)',
            'Analysis and improvement of service use',
            'Overseas processing (Article 8)',
          ],
        ],
      },
      ``,
      `② When entering into an entrustment agreement, the Company specifies matters such as the prohibition of processing beyond the entrusted purpose, technical and administrative safeguards, restrictions on re-entrustment, supervision, and liability for damages, and supervises the entrusted parties on a regular basis. If an entrusted party or the content of the entrusted task changes, the Company discloses this through this Policy without delay.`,
    ],
  },
  {
    heading: 'Article 8 (Cross-Border Transfer of Personal Information)',
    body: [
      `① The Company's servers (AWS) are located in the Republic of Korea (Seoul region). However, personal information may be processed overseas through the entrusted parties set out below. In accordance with Article 28-8 of the Personal Information Protection Act, the Company discloses this fact and, where necessary, obtains the consent of the data subject or satisfies the statutory requirements.`,
      {
        type: 'table',
        headers: [
          'Recipient',
          'Country of transfer',
          'Items transferred',
          'Purpose and retention period',
        ],
        rows: [
          [
            'Google LLC',
            'United States and others',
            'Access and usage analytics data, session usage information',
            "Service analysis and provision of live sessions / in accordance with each service's policy",
          ],
          [
            'Microsoft Corp.',
            'United States and others',
            'Behavioural analytics data',
            "Usability improvement / in accordance with each service's policy",
          ],
          [
            'PayPal',
            'United States and others',
            'Payment-related information',
            "Overseas payment processing / in accordance with each service's policy",
          ],
        ],
      },
      ``,
      `② The exact country of transfer, the date and method of transfer, and the retention period for each entrusted party are to be confirmed according to the relevant contracts and service settings and reflected in this Policy.`,
    ],
  },
  {
    heading:
      'Article 9 (Installation, Operation, and Refusal of Automatic Collection Devices such as Cookies)',
    body: [
      `① The Company uses cookies for service operation and analysis of usage, and may collect behavioural data through Google Analytics 4 and Microsoft Clarity.`,
      ``,
      `② Users may refuse the storage of cookies through their browser settings. In that case, use of some parts of the Service may be limited.`,
      ``,
      `③ The Company provides a consent procedure, such as a cookie consent banner, so that Users can choose whether to consent to the collection of behavioural information through analytics tools.`,
    ],
  },
  {
    heading:
      'Article 10 (Rights and Obligations of Data Subjects and How to Exercise Them)',
    body: [
      `① Data subjects may at any time request access to their personal information, correction or deletion, suspension of processing, and withdrawal of consent.`,
      ``,
      `② The Company decides and notifies whether to grant access within 10 days of receiving a request for access, and takes action on requests for correction or deletion (Article 36) and suspension of processing (Article 37) within the periods prescribed by applicable laws.`,
      ``,
      <>
        ③ Rights may be exercised through{' '}
        <a href='mailto:contact@ko-ready.com' className='underline'>
          contact@ko-ready.com
        </a>{' '}
        or through Settings &gt; Delete account. The Company takes action after
        verifying the identity of the requester. Where a request is made through
        an agent, a power of attorney must be submitted.
      </>,
    ],
  },
  {
    heading:
      'Article 11 (Procedures and Methods for Destroying Personal Information)',
    body: [
      `① The Company identifies personal information for which the retention period has expired or the purpose of processing has been achieved, and destroys it without delay.`,
      ``,
      `② Electronic files are deleted using technical methods that make them unrecoverable and unreproducible, and paper documents are shredded or incinerated.`,
    ],
  },
  {
    heading:
      'Article 12 (Measures to Secure the Safety of Personal Information)',
    body: [
      `In accordance with Article 29 of the Personal Information Protection Act, the Company takes the following measures: establishment and implementation of an internal management plan, management of access rights to personal information and access control, encryption of personal information, storage of access records and prevention of forgery or alteration, and training of personnel who handle personal information.`,
    ],
  },
  {
    heading: 'Article 13 (Personal Information Protection Officer)',
    body: [
      `① The Company designates a Personal Information Protection Officer to oversee personal information processing and to handle grievances from data subjects.`,
      ``,
      <>
        ② Personal Information Protection Officer: Hayeon Kwon / Contact:{' '}
        <a href='mailto:contact@ko-ready.com' className='underline'>
          contact@ko-ready.com
        </a>
      </>,
    ],
  },
  {
    heading: 'Article 14 (Remedies for Infringement of Rights)',
    body: [
      `Data subjects may apply to the following bodies for dispute resolution or consultation regarding personal information infringement.`,
      <>
        · Personal Information Dispute Mediation Committee: 1833-6972 (
        <a
          href='https://www.kopico.go.kr'
          target='_blank'
          rel='noopener noreferrer'
          className='underline'
        >
          www.kopico.go.kr
        </a>
        )
      </>,
      <>
        · Personal Information Infringement Report Centre: 118 (
        <a
          href='https://privacy.kisa.or.kr'
          target='_blank'
          rel='noopener noreferrer'
          className='underline'
        >
          privacy.kisa.or.kr
        </a>
        )
      </>,
      `· Supreme Prosecutors' Office Cyber Investigation Division: 1301 / National Police Agency Cyber Bureau: 182`,
    ],
  },
  {
    heading: 'Article 15 (Changes to this Privacy Policy)',
    body: [
      `This Policy may be amended in line with changes in applicable laws or the Service. The Company will give notice by email or website notice at least 30 days before the effective date where the change is unfavourable to Users, and at least 7 days before the effective date in all other cases.`,
    ],
  },
  {
    chapter: 'Supplementary Provisions',
    heading: 'Official version and contact',
    body: [
      `This English version is a translation provided for the convenience of Users. The Korean version of this Privacy Policy is the official version. In the event of any conflict or difference in interpretation between the Korean and English versions, the Korean version prevails. This does not apply where the laws of the User's habitual residence provide otherwise for the protection of personal information or consumers.`,
      ``,
      <>
        Koready |{' '}
        <a href='mailto:contact@ko-ready.com' className='underline'>
          contact@ko-ready.com
        </a>{' '}
        | Personal Information Protection Officer: Hayeon Kwon
      </>,
      ``,
      <>
        See also the{' '}
        <Link to='/terms' className='underline'>
          Terms of Use
        </Link>
        .
      </>,
    ],
  },
];

/** 정책 문서 한 버전. PolicyDocument가 레지스트리를 통해 읽어 렌더링한다. */
export default {
  title: 'Privacy Policy',
  lastUpdated: 'August 28, 2026',
  effectiveDate: '2026-08-28',
  sections,
};
